export enum MenuItemType {
  divider = 'divider',
  headingAndDivider = 'headingAndDivider',
  dividerWithCollection = 'dividerWithCollection',
  item = 'item',
}

export type BaseMenuItem = {
  type: MenuItemType;
  label?: string;
  icon?: string | null;
  shouldOpenInNewWindow?: boolean;
  count?: number;
  href?: string;
  isBold?: boolean;
  isMainCollection?: boolean;
  isTopMenu?: boolean;
};
export type MenuItemWithSubMenu<T> = BaseMenuItem & {
  subMenu?: Array<T>;
};
export type MenuData = {
  label: string;
  href?: string;
  menuItems: Array<MenuItemWithSubMenu<MenuItemWithSubMenu<BaseMenuItem>>>;
};
